import React from "react";
import "../../Pages/Projects/project.css";

// Renders the project's commission_status as a colored pill, consistent
// across the Projects list and Deals Assigned pages. `amount` is optional —
// pass project.commission_amount to show the dollar figure alongside status.
// `required` is project.commission_required — pass it whenever it's
// available so a grandfathered-in project (posted before the commission
// feature existed) reads as exempt rather than "not set up yet".
const CommissionBadge = ({ status, amount, required }) => {
  const formattedAmount = amount != null && !isNaN(Number(amount))
    ? `$${Number(amount).toFixed(2)}`
    : null;

  if (required === false) {
    return <div className="commission-badge commission-badge--none">Won&apos;t be charged</div>;
  }

  if (!status) {
    return <div className="commission-badge commission-badge--none">Not set up</div>;
  }

  if (status === "pending") {
    return (
      <div className="commission-badge commission-badge--pending">
        Pending{formattedAmount ? ` — ${formattedAmount}` : ""}
      </div>
    );
  }

  if (status === "charged") {
    return (
      <div className="commission-badge commission-badge--charged">
        Charged{formattedAmount ? ` — ${formattedAmount}` : ""}
      </div>
    );
  }

  if (status === "failed") {
    return (
      <div className="commission-badge commission-badge--failed">
        Failed{formattedAmount ? ` — ${formattedAmount}` : ""}
      </div>
    );
  }

  return <div className="commission-badge commission-badge--none">{status}</div>;
};

export default CommissionBadge;
